import { lazy } from 'react';

import type { TabKenh } from '../channels/tabRegistry.js';

/** Tab "Bản quyền" của trang chi tiết kênh. Order 80 theo docs/modules/_ban-do-phu-thuoc.md. */
const channelTabs: TabKenh[] = [
  {
    id: 'ban-quyen',
    nhom: 'ban-quyen',
    label: 'Sự cố bản quyền',
    order: 80,
    permission: { module: 'compliance', level: 'view' },
    component: lazy(() => import('./components/TabTuanThuCuaKenh.js')),
  },
];

export default channelTabs;
